// Import et traitement des données régions depuis le CSV
export const regionsData = [
    { id_region: "11", nom_region: "ANALAMANGA" },
    { id_region: "12", nom_region: "VAKINANKARATRA" },
    { id_region: "13", nom_region: "ITASY" },
    { id_region: "14", nom_region: "BONGOLAVA" },
    { id_region: "21", nom_region: "HAUTE MATSIATRA" },
    { id_region: "22", nom_region: "AMORON I MANIA" },
    { id_region: "23", nom_region: "VATOVAVY FITOVINANY" },
    { id_region: "24", nom_region: "IHOROMBE" },
    { id_region: "25", nom_region: "ATSIMO ATSINANANA" },
    { id_region: "31", nom_region: "ATSINANANA" },
    { id_region: "32", nom_region: "ANALANJIROFO" },
    { id_region: "33", nom_region: "ALAOTRA MANGORO" },
    { id_region: "41", nom_region: "BOENY" },
    { id_region: "42", nom_region: "SOFIA" },
    { id_region: "43", nom_region: "BETSIBOKA" },
    { id_region: "44", nom_region: "MELAKY" },
    { id_region: "51", nom_region: "ATSIMO ANDREFANA" },
    { id_region: "52", nom_region: "ANDROY" },
    { id_region: "53", nom_region: "ANOSY" },
    { id_region: "54", nom_region: "MENABE" },
    { id_region: "71", nom_region: "DIANA" },
    { id_region: "72", nom_region: "SAVA" }
];

// Fonction pour vérifier si une région est valide
export const isValidRegion = (regionName) => {
    if (!regionName) return false;
    const normalizedName = regionName.trim().toUpperCase().replace(/\s+/g, ' ');

    return regionsData.some(region => {
        const csvRegionName = region.nom_region.trim().toUpperCase();
        return csvRegionName === normalizedName ||
            csvRegionName.includes(normalizedName) ||
            normalizedName.includes(csvRegionName);
    });
};

// Fonction pour normaliser le nom de région selon le CSV
export const normalizeRegionName = (regionName) => {
    if (!regionName) return null;

    const normalizedName = regionName.trim().toUpperCase().replace(/[-–—]/g, ' ').replace(/\s+/g, ' ');

    // 1. Correspondances exactes
    for (const region of regionsData) {
        const csvRegionName = region.nom_region.trim().toUpperCase();
        if (csvRegionName === normalizedName) {
            return region.nom_region;
        }
    }

    // 2. Correspondances partielles prioritaires (cas complexes)
    if (normalizedName.includes('VATOVAVY')) return 'VATOVAVY FITOVINANY';
    if (normalizedName.includes('VAKINANKA')) return 'VAKINANKARATRA';
    if (normalizedName.includes('HAUTE') && normalizedName.includes('MATSIATRA')) return 'HAUTE MATSIATRA';
    if (normalizedName.includes('MATSIATRA') && normalizedName.includes('AMBONY')) return 'HAUTE MATSIATRA';
    if (normalizedName.includes('AMORON') && normalizedName.includes('MANIA')) return 'AMORON I MANIA';
    if (normalizedName.includes('ALAOTRA') || normalizedName.includes('MANGORO')) return 'ALAOTRA MANGORO';
    if (normalizedName.includes('ATSIMO') && normalizedName.includes('ATSINANANA')) return 'ATSIMO ATSINANANA';
    if (normalizedName.includes('ATSIMO') && normalizedName.includes('ANDREFANA')) return 'ATSIMO ANDREFANA';
    if (normalizedName.includes('ATSINANANA') || normalizedName.includes('ANTSINANANA')) return 'ATSINANANA';

    // 3. Correspondances permissives (si contient ou est contenu dans)
    for (const region of regionsData) {
        const csvRegionName = region.nom_region.trim().toUpperCase();
        if (csvRegionName.includes(normalizedName) || normalizedName.includes(csvRegionName)) {
            return region.nom_region;
        }
    }

    return null; // Région non trouvée
};



// Palette de couleurs pour les régions valides
export const regionColors = {
    'ANALAMANGA': '#F1948A',
    'VAKINANKARATRA': '#7FB3D5',
    'ITASY': '#F8B739',
    'BONGOLAVA': '#D5A6BD',
    'HAUTE MATSIATRA': '#BB8FCE',
    'AMORON I MANIA': '#FAD7A0',
    'VATOVAVY FITOVINANY': '#F9E79F',
    'IHOROMBE': '#85C1E2',
    'ATSIMO ATSINANANA': '#AED6F1',
    'ATSINANANA': '#F8C471',
    'ANALANJIROFO': '#98D8C8',
    'ALAOTRA MANGORO': '#A9DFBF',
    'BOENY': '#98D8C8',
    'SOFIA': '#C39BD3',
    'BETSIBOKA': '#F7DC6F',
    'MELAKY': '#52C777',
    'ATSIMO ANDREFANA': '#D7BDE2',
    'ANDROY': '#AED6F1',
    'ANOSY': '#82E0AA',
    'MENABE': '#FF8C94',
    'DIANA': '#DDA0DD',
    'SAVA': '#52C777'
};

export default regionsData;
